import React, { useState } from "react";
import Header from "../layouts/Employee/Header";
import SubHeader from "../layouts/Employee/SubHeader";
import "./MyTeam.css";
import MyTeamLayout from "../layouts/Employee/MyTeamLayout";

function MyTeam() {
  return (
    <div className="myTeamBg">
      <Header />
      <SubHeader />
      <MyTeamLayout />
    </div>
  );
}

export default MyTeam;
